import type { IconData } from '@stacksjs/iconify-core'

export const otherUiMousePointer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 4L0 0l4 16l2-6l6 6l4-4l-6-6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiMousePointer
